import React from 'react';
import { useTranslation } from 'react-i18next';
import StatusPill, { StatusVariant } from '../../patterns/StatusPill';

export type SprayStatus =
  | 'draft'
  | 'planned'
  | 'not_started'
  | 'in_progress'
  | 'completed'
  | 'incomplete'
  | 'cancelled'
  | 'deleted';

const VARIANT_BY_STATUS: Record<SprayStatus, StatusVariant> = {
  'draft': 'info',
  'planned': 'warn',
  // Per-combo lifecycle: a combo with no work yet renders with the same
  // "needs attention" treatment as a planned parent session.
  'not_started': 'warn',
  'in_progress': 'ok',
  'completed': 'info',
  // A combo that ended without completing the spray.
  'incomplete': 'danger',
  'cancelled': 'danger',
  'deleted': 'info',
};

export interface SessionStatusPillProps {
  status: SprayStatus | string;
}

const SessionStatusPill: React.FC<SessionStatusPillProps> = ({ status }) => {
  const { t } = useTranslation();
  const variant = VARIANT_BY_STATUS[status as SprayStatus] ?? 'info';
  const labelKey = `spray.statusLabels.session.${status}`;
  const label = t(labelKey, { defaultValue: status });
  return (
    <span data-testid="session-status-pill">
      <StatusPill variant={variant}>{label}</StatusPill>
    </span>
  );
};

export default SessionStatusPill;
